export class EsitoTest {
  type: string;
  message: string;
  title: string;
  typeCss: string;
  voto: number;
}

export class SelfStudyAccordionModel {
  public header: String;
  public title: String;
  public descrizione: String;
  public haveLink: boolean;
  public link: String;
}

export class PercentualeStudio {
  titolo: string;
  descrizione: string;
  percentualeCorrente: string;
  percentualeSuperamento: string;
  oreTotali: number;
  oreEffettuate: number;
  oreMinimeTotali: number;
  viewOreMinimeTotali: number;
}

export class PercentualiStudio {
  lezioniInAula: PercentualeStudio;
  laboratorio: PercentualeStudio;
  selfStudy: PercentualeStudio;

  constructor() {
    this.lezioniInAula = new PercentualeStudio();
    this.laboratorio = new PercentualeStudio();
    this.selfStudy = new PercentualeStudio();
  }
}

export class PagebleList {
  public skip: number;
  public take: number;
  public offset: number;
  public count: number;
  public currentPage: number;
  public pages: number;
  public haveNextPage: boolean;
  public havePreviousPage: boolean;
}

export class ListMenuUtenteDTO {
  public menu: MenuUtenteDTO[];
}

export class MenuUtenteDTO {
  public label: string;
  public route: string;
  public separator: Boolean;
  public isRedirect: Boolean;
  public iconClasses: string;
  public children: MenuUtenteDTO[];
}

export class UtenteDTO {
  public id: number;
  public username: string;
  public token: string;
  public tipoStudente: string;
  public studente: StudenteDTO;
  public instructorOrTutor: InstructorOrTutorDTO;
  public gruppo: GruppoDTO;
  public fotoProfiloUtente: any;
  public haveFotoProfiloUtente: boolean;
}

export class StudenteDTO {
  public id: number;
  public nome: string;
  public cognome: string;
  public matricola: string;
  public email: string;
  public corsoLaurea: CorsoDiLaureaDTO;
  public gruppoStudio: GruppoStudioDTO;
  public haveGruppoStudio: boolean;
  public sessioneOla: SessioneOlaDTO;
  public sessioneOlaStudente: SessioneOlaStudenteDTO;
  public checkedAppello: boolean;
  public numeroRipetizioni: number;
  public verificaOrePrenotazione: boolean;
  public idoneo: boolean;
  public dataCaricamentoAgenda: Date;
  public idUtenteApprovazioneAgenda: number;
  public nomeUtenteApprovazioneAgenda: string;
}

export class SessioneOlaStudenteDTO {
  public id: number;
  public idGruppoStudio: number;
  public idStudente: number;
  public idCorsoDiLaurea: number;
  public idSessioneOla: number;
  public idTurnoEsame: number;
  public oreInAula: number;
  public oreInLaboratorio: number;
  public oreStudioInAutonomia: number;
  public oreRecupero: number;
  public votoPlacementTest: number;
  public esitoPositivoPlacementTest: boolean;
  public obbligoRecupero: boolean;
  public esonerato: boolean;
  public agendaStudioAutonomia: boolean;
  public agendaStudioAutonomiaVerificata: boolean;
  public dataInserimento: Date;
  public note: string;
  public votoProvaFinale: number;
  public votoProvaFinaleOrale: String;
  public oraleFacoltativo: boolean;
  public newAgenda: boolean;

  public esoneroAgendaStudio: boolean;
  public esoneroOreInAula: boolean;
  public esoneroOreInLaboratorio: boolean;

  public numeroDownloadAttestato: number;
}

export class ResponseGeneraAssociazioneStudenteGruppoDTO {
  public esito: boolean;
  public message: string;
}

export class SessioneOlaDTO {
  public id: number;
  public nome: string;
  public anno: number;
  public mese: number;
  public durataSessione: number;
  public active: boolean;
  public numeroDocumenti: number;
  public nomeDoc1: string;
  public nomeDoc2: string;
  public nomeDoc3: string;
  public idDoc1: number;
  public idDoc2: number;
  public idDoc3: number;
}

export class SelectDTO {
  public value: string;
  public viewValue: string;
}

export class PrivilegioDTO {
  public id: number;
  public descrizione: string;
  public codice: string;
}

export class PercentualiStudioDTO {
  public lezioniInAula: PercentualeStudioDTO;
  public laboratorio: PercentualeStudioDTO;
  public selfStudy: PercentualeStudioDTO;
}

export class PercentualeStudioDTO {
  //FORSE NON VIENE PROPRIO USATO
  public titolo: string;
  public descrizione: string;
  public percentualeCorrente: string;
  public percentualeSuperamento: string;
  public oreTotali: number;
  public oreEffettuate: number;
  public oreMinimeTotale: number;
}

export class PrenotatiProvaFinaleDTO {
  public id: number;
  public studente: StudenteDTO;
  public provaFinale: ProvaFinaleDTO;
}

export class ListUtentiDTO extends PagebleList {
  public utente: UtenteDTO[];
}

export class ListPrenotatiProveFinaliDTO extends PagebleList {
  public prenotatiProveFinali: PrenotatiProvaFinaleDTO[];
}

export class ListStudentiDTO extends PagebleList {
  public studenti: StudenteDTO[];
}

export class ListSessioniOlaDTO extends PagebleList {
  public sessioniOla: SessioneOlaDTO[];
}

export class ListSessioneOlaStudenteDTO extends PagebleList {
  public sessioneOlaStudenti: SessioneOlaStudenteDTO[];
}

export class ListSelectDTO {
  public list: SelectDTO[];
}

export class ListPrivilegiDTO extends PagebleList {
  public list: PrivilegioDTO[];
}

export class ListLanguageLevelsDTO extends PagebleList {
  public languageLevels: LanguageLevelDTO[];
}

export class ListInstructorsOrTutorsDTO extends PagebleList {
  public instructorsOrTutors: InstructorOrTutorDTO[];
}

export class ListGruppoStudioLanguageLevelsDTO extends PagebleList {
  public gruppoStudioLanguageLevels: GruppoStudioLanguageLevelDTO[];
}

export class ListGruppoStudioCorsiLaureaDTO extends PagebleList {
  public gruppoStudioCorsiLaure: GruppoStudioCorsoLaureaDTO[];
}

export class ListGruppiStudioDTO extends PagebleList {
  public gruppiStudio: GruppoStudioDTO[];
}

export class ListGruppiDTO extends PagebleList {
  public gruppi: GruppoDTO[];
}

export class ListCorsiDiLaureaDTO extends PagebleList {
  public corsiDiLaurea: CorsoDiLaureaDTO[];
}

export class ListAuleDTO extends PagebleList {
  public aule: AulaDTO[];
}

export class LanguageLevelDTO {
  public id: number;
  public nome: string;
}

export class ListGruppoStudioPresenze extends PagebleList {
  public gruppoStudioPresenze: GruppoStudioPresenze[];
}

export class ListLaboratorioPresenze extends PagebleList {
  public laboratorioPresenze: LaboratorioPresenze[];
}

export class GruppoStudioPresenze {
  public id: number;
  public dataAppello: string;
  public oraAppello: string;
  public instructor: InstructorOrTutorDTO;
  public dataEffettuatoAppello: Date;
  public effettuato: Boolean;
  public studenti: ListStudentiDTO;
}

export class LaboratorioPresenze {
  public id: number;
  public laboratorio: LaboratorioLezioneTutoraggioDTO;
  public tutor: InstructorOrTutorDTO;
  public effettuato: boolean;
  public studenti: ListStudentiDTO;
  public dataEffettuatoAppello: Date;
}

export class InstructorOrTutorDTO {
  public id: number;
  public nome: string;
  public cognome: string;
  public telefono: string;
  public email: string;
  public active: boolean;
  public gruppo: GruppoDTO;
  public type: boolean; // 0 instructor , 1 tutor
}

export class GruppoStudioLanguageLevelDTO {
  public id: number;
  public idGruppoStudio: number;
  public idCorsoLaurea: number;
}

export const TIPOLOGIA = {
  ABILITATI: 'ATTIVI',
  DISABILITATI: 'DISATTIVATI',
};

export class GruppoStudioDTO {
  public id: number;
  public nome: string;
  public instructors: ListInstructorsOrTutorsDTO;
  public note: string;
  public active: boolean;
  public corsiLaurea: ListCorsiDiLaureaDTO;
  public languageLevels: ListLanguageLevelsDTO;
  public listAuleLezioneGruppoStudio: ListAuleLezioneGruppiStudioDTO;
  public studenti: ListStudentiDTO;
  public dataInserimento: Date;
  public sessioneOla: SessioneOlaDTO;
  public idUtente: number;
  public numeroStudentiMassimo: number;
  public percentualeAttivazioneOreRecupero: number;
  public sogliaMinimaOreInAula: number;
  public sogliaMinimaOreInLaboratorio: number;
  public totaleOreInAula: number;
  public totaleOreInLaboratorio: number;
  public totaleOreRecupero: number;
  public totaleOreStudioInAutonomia: number;
  public votoMinimoSuperamentoPlacement: number;
  public votoMassimoSuperamentoPlacement: number;
  public votoMinimoSuperamentoProvaFinale: number;
  public votoMassimoSuperamentoProvaFinale: number;
  public dataInizio: Date;
  public esoneroAgendaStudio: boolean;
  public esoneroOreInAula: boolean;
  public esoneroOreInLaboratorio: boolean;
}

export class GruppoStudioCorsoLaureaDTO {
  public id: number;
  public idGruppoStudio: number;
  public idCorsoLaurea: number;
  public active: boolean;
}

export class GruppoDTO {
  public id: number;
  public nome: string;
  public descrizione: string;
  public privilegi: ListPrivilegiDTO;
  public permessiScrittura: boolean;
}

export class EsitoTestDTO {
  public type: string;
  public message: string;
  public title: string;
  public voto: number;
  public typeCss: string;
}

export class CorsoDiLaureaDTO {
  public id: number;
  public nome: string;
  public active: boolean;
  public obbligoOrale: boolean;
}

export class AulaDTO {
  public id: number;
  public nome: string;
  public cubo: string;
  public numeroPostazioni: number;
  public contattiNoteAggiuntive: string;
  public active: boolean;
  public tipo: string;
}

export class AulaLezioneGruppoStudioDTO {
  public id: number;
  public giornoSettimana: string;
  public aula: AulaDTO;
  public orarioInizio: string;
  public orarioFine: string;
  public gruppoStudio: GruppoStudioDTO;
  public nomeGruppoStudio: string;
}

export class ListAuleLezioneGruppiStudioDTO extends PagebleList {
  public auleLezioneGruppoStudio: AulaLezioneGruppoStudioDTO[];
}

export class ListLaboratorioLezioneTutoraggioDTO extends PagebleList {
  public laboratoriLezioneTutoraggio: LaboratorioLezioneTutoraggioDTO[];
}

export class ListStudentePrenotazioneLaboratorioDTO extends PagebleList {
  public studentiPrenotazioniLaboratorio: StudentePrenotazioneLaboratorioDTO[];
}

export class StudentePrenotazioneLaboratorioDTO {
  public id: number;
  public studente: StudenteDTO;
  public laboratorioLezioneTutoraggio: LaboratorioLezioneTutoraggioDTO;
}

export class ProvaFinaleDTO {
  public nome: string;
  public id: number;
  public dataProva: Date;
  public dataMassimaPrenotazione: Date;
  public dataMinimaPrenotazione: Date;
  public corsiLaurea: ListCorsiDiLaureaDTO;
  public aula: AulaDTO;
  public active: boolean;
  public numeroPrenotatiProvaFinale: number;
  public orale: boolean;
}

export class MioGruppoStudioDTO {
  public id: number;
  public nome: string;
  public percentualeSelfStudyComplessiva: string;
  public percentualeLaboratorioComplessiva: string;
  public percentualeOreAulaComplessiva: string;
  public percentualeOreAulaComplessivaInstructor: string;
  public corsiDiLaurea: string;
  public numeroStudenti: number;
}

export class ListMieiGruppiStudioDTO {
  public gruppiStudio: MioGruppoStudioDTO[];
  public auleLezioneGruppoStudio: AulaLezioneGruppoStudioDTO[];
}

export class ListProveFinaliDTO extends PagebleList {
  public proveFinali: ProvaFinaleDTO[];
}

export class ProveEsamiDisponibiliDTO {
  public disponibili: boolean;
  public proveEsami: ListProveFinaliDTO;
}

export class LaboratorioLezioneTutoraggioDTO {
  public active: boolean;
  public dataFine: Date;
  public dataInizio: Date;
  public dataInserimento: Date;
  public id: number;
  public aula: AulaDTO;
  public tutor: InstructorOrTutorDTO;
  public idUtente: number;
  public postiDisponibili: number;
  public postiTotali: number;
  public sessioneOla: SessioneOlaDTO;
  public appelloEffettuato: boolean;
  public appelloTutorEffettuato: boolean;
  public inPresenza: boolean;
}

export class ListMieiLaboratoriDTO {
  public laboratoriLezioneTutoraggio: LaboratorioLezioneTutoraggioDTO[];
  public laboratoriLezioneTutoraggioPrecedenti: LaboratorioLezioneTutoraggioDTO[];
}

export class LogOperazioneDTO {
  public id: number;
  public idUtenteOperazione: number;
  public tipoOperazione: string;
  public messaggioOperazione: string;
}

export class ListLogOperazioneDTO extends PagebleList {
  public logOperazioni: LogOperazioneDTO[];
}

export class CategorySelfStudyDTO {
  public id: number;
  public idUtente: number;
  public nome: string;
  public dataInserimento: Date;
  public ordinamento: string;
}

export class ListCategorySelfStudyDTO extends PagebleList {
  public categoriesSelfStudy: CategorySelfStudyDTO[];
}

export class SelfStudyDocumentDTO {
  public id: number;
  public idUtente: number;
  public nome: string;
  public descrizione: string;
  public link: string;
  public categorySelfStudy: CategorySelfStudyDTO;
  public dataInserimento: Date;
  public ordinamento: string;
}

export class ListSelfStudyDocumentDTO extends PagebleList {
  public selfStudyDocuments: SelfStudyDocumentDTO[];
}

export class BoxPrenotazioneLaboratorioDTO {
  public header: string;
  public id: number;
  public tutors: string[];
  public dayHours: DayHoursDTO;
  public listHourPosti: HoursPostiDTO[];
}

export class ListBoxPrenotazioneLaboratorioDTO extends PagebleList {
  public boxesPrenotazioneLaboratorio: BoxPrenotazioneLaboratorioDTO[];
  public dayHours: DayHoursDTO[];
  public hoursPosti: HoursPostiDTO[];
}

export class HoursPostiDTO {
  public hour: string;
  public postiDisponibili: number;
  public postiTotali: number;
  public inPresenza: boolean;
}

export class DayHoursDTO {
  date: string;
  hours: string[];
  hour: string;
}

export class RisultatoProvaFinaleDTO {
  voto: string;
  dataProvaFinale: Date;
}

export class ListRisultatoProvaFinaleDTO {
  storicoScritto: RisultatoProvaFinaleDTO[];
  storicoOrale: RisultatoProvaFinaleDTO[];
}

export class GoToModel {
  public params: string;
  public url: string;
}

export class BarChart {
  public data: any[];
  public label: string;
}

export class ListBarChart {
  public barChart : BarChart[];
  public label : String[];
}

export class LineChart {
  public data: any[];
  public label: string;
}

export class ListStudenteGraficoDTO {
  listStudentiGraficoDTO: StudenteGraficoDTO[];
}

export class StudenteGraficoDTO {
  idStudente: number;
	nome: string;
	cognome: string;
	matricola: string;
  idSessioneAppartenenza : number;
  idCorsoDiLaurea : number;
  nomeCorsoDiLaurea : string;
	idGruppo: number;
	nomeGruppo: string;
	sogliaGruppo: number;
	idProva: number;
  idSessioneProva: number;
	dataProva: Date;
	votoProva: number;
	votoProvaOrale: string;
	superata: boolean;
	tentativi: number;
}
